import {
  FETCH_TICKETS_REQUEST,
  FETCH_TICKETS_SUCCESS,
  FETCH_TICKETS_FAILURE,
  SELECT_TICKET,
  FOCUS_TICKET,
  FOCUS_TICKET_POSITION,
  NEW_SUPPORT_TICKET,
  DISMISS_TICKETS_ERROR,
} from '../actions/support/tickets'

import {
  FETCH_TICKET_TYPES_REQUEST,
  FETCH_TICKET_TYPES_SUCCESS,
  FETCH_TICKET_TYPES_FAILURE,
  STEP_ONE_FOCUS_POSITION,
  STEP_ONE_FOCUS,
  STEP_ONE_SELECT,
  STEP_ONE_STATUS_FAILED,
} from '../actions/support/tickets-new-step-one'

import {
  STEP_TWO_FOCUS_POSITION,
  STEP_TWO_FOCUS,
  STEP_TWO_SELECT,
  STEP_TWO_FETCH_OPTIONS,
} from '../actions/support/tickets-new-step-two'

import {
  FETCH_CHANNELS_REQUEST,
  FETCH_CHANNELS_SUCCESS,
  FETCH_CHANNELS_FAILURE,
  STEP_THREE_FOCUS_POSITION,
  STEP_THREE_FOCUS,
  STEP_THREE_SELECT,
} from '../actions/support/tickets-new-step-three'

import {
  FETCH_TICKET_DETAILS_REQUEST,
  FETCH_TICKET_DETAILS_SUCCESS,
  FETCH_TICKET_DETAILS_FAILURE,
  FOCUS_LOG,
  FOCUS_LOG_POSITION,
  DISMISS_LOGS_ERROR,
} from '../actions/support/ticket-details'

import {
  REPLY_INPUT_MESSAGE,
  REPLY_INPUT_TITLE,
  REPLY_STATUS_WAITING,
  REPLY_STATUS_PROCESSING,
  REPLY_STATUS_SUCCESS,
  REPLY_STATUS_FAILED,
} from '../constants/reply'

import {
  REPLY_LOG_INPUT_MESSAGE,
  REPLY_LOG_STATUS_WAITING,
  REPLY_LOG_STATUS_PROCESSING,
  REPLY_LOG_STATUS_SUCCESS,
  REPLY_LOG_STATUS_FAILED,
} from '../constants/reply-log'

import {
  FOCUS_INPUT,
  UPDATE_INPUT,
  DELETE_INPUT,
  ERROR_INPUT,
  REPLY_REQUEST,
  REPLY_SUCCESS,
  REPLY_FAILURE,
  SET_STATUS,
  FOCUS_KEYBOARD,
  RESET_REPLY,
} from '../actions/support/reply'

import {
  FOCUS_LOG_INPUT,
  UPDATE_LOG_INPUT,
  DELETE_LOG_INPUT,
  ERROR_LOG_INPUT,
  REPLY_LOG_REQUEST,
  REPLY_LOG_SUCCESS,
  REPLY_LOG_FAILURE,
  SET_LOG_STATUS,
  FOCUS_LOG_KEYBOARD,
} from '../actions/support/reply-log'

import { LOGIN_SUCCESS } from '../actions/login'
import { LOGOUT_SUCCESS } from '../actions/logout'

const INITIAL_STATE = {
  isReady: false,
  hasError: false,
  errorMessage: '',
  previousId: -1,
  selectedTicketId: -1,
  focusedTicketId: -1,
  focusedTicketPosition: -1,
  tickets: [],
  ticketsById: {},
  newTicketStepOne: {
    isReady: false,
    hasError: false,
    errorMessage: '',
    status: '',
    stepOneTypes: [],
    stepOnePositionFocusId: -1,
    stepOneFocusId: -1,
    stepOneSelectedId: -1,
  },
  newTicketStepTwo: {
    isReady: false,
    hasError: false,
    errorMessage: '',
    stepTwoTypes: [],
    stepTwoFocusId: -1,
    stepTwoSelectedId: -1,
  },
  newTicketStepThree: {
    isReady: false,
    hasError: false,
    errorMessage: '',
    status: '',
    stepThreeChannelsbyId: {},
    stepThreeChannelsAllIds: [],
    stepThreePositionFocusId: -1,
    stepThreeFocusId: -1,
  },
  ticketDetails: {
    isReady: false,
    hasError: false,
    errorMessage: '',
    details: {},
    logsId: [],
    logsById: {},
    focusedLogId: -1,
    focusedLogPosition: -1,
  },
  reply: {
    status: REPLY_STATUS_WAITING,
    focusedInput: REPLY_INPUT_TITLE,
    keyboardFocused: true,
    focusedRow: 0,
    focusedCol: 0,
    errors: {},
    statusReason: '',
  },
  replyLog: {
    status: REPLY_LOG_STATUS_WAITING,
    focusedInput: REPLY_LOG_INPUT_MESSAGE,
    keyboardFocused: true,
    focusedRow: 0,
    focusedCol: 0,
    errors: {},
    statusReason: '',
  },
}
INITIAL_STATE.reply[REPLY_INPUT_MESSAGE] = ''
INITIAL_STATE.reply.errors[REPLY_INPUT_MESSAGE] = ''

INITIAL_STATE.reply[REPLY_INPUT_TITLE] = ''
INITIAL_STATE.reply.errors[REPLY_INPUT_TITLE] = ''

INITIAL_STATE.replyLog[REPLY_LOG_INPUT_MESSAGE] = ''
INITIAL_STATE.replyLog.errors[REPLY_LOG_INPUT_MESSAGE] = ''

const ticketsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_TICKETS_REQUEST:
      return {
        ...state,
        isReady: false,
        hasError: false,
        errorMessage: '',
      }
    case FETCH_TICKETS_SUCCESS:
      let tickets = []
      let ticketsById = {}
      action.payload.tickets.forEach(ticket => {
        ticketsById[ticket.id] = ticket
        tickets.push(ticket.id)
      })
      return {
        ...state,
        isReady: true,
        hasError: false,
        errorMessage: '',
        tickets: tickets,
        ticketsById: ticketsById,
        focusedTicketId: tickets.length > 0 ? tickets[0] : -1,
        focusedTicketPosition: tickets.length > 0 ? 0 : -1,
        previousId: tickets.length > 0 ? tickets[0] : -1,
      }
    case FETCH_TICKETS_FAILURE:
      return {
        ...state,
        isReady: true,
        hasError: true,
        errorMessage:
          action.payload instanceof Error && action.payload.message !== ''
            ? action.payload.message
            : 'An error occurred while trying to load the tickets',
      }
    case FOCUS_TICKET:
      return {
        ...state,
        focusedTicketId: action.payload.id,
        previousId:
          state.focusedTicketId !== -1 ? state.focusedTicketId : state.previousId,
      }
    case FOCUS_TICKET_POSITION:
      return {
        ...state,
        focusedTicketPosition: action.payload.position,
      }
    case SELECT_TICKET:
      return {
        ...state,
        selectedTicketId: action.payload.id,
        focusedTicketId: action.payload.id,
        previousId: action.payload.id,
      }
    case DISMISS_TICKETS_ERROR:
      return {
        ...state,
        isReady: true,
        hasError: false,
        errorMessage: '',
      }

    case FETCH_TICKET_TYPES_REQUEST:
      return {
        ...state,
      }

    case FETCH_TICKET_TYPES_SUCCESS:
      let types = []
      action.payload.types.forEach(type => {
        types.push(type)
      })

      return {
        ...state,
        newTicketStepOne: {
          ...state.newTicketStepOne,
          isReady: true,
          stepOneTypes: types,
          stepOnePositionFocusId:
            action.payload.types.length > 0 ? Object.keys(types)[0] : -1,
          stepOneFocusId:
            action.payload.types.length > 0 ? action.payload.types[0].id : -1,
        },
      }
    case FETCH_TICKET_TYPES_FAILURE:
      return {
        ...state,
        newTicketStepOne: {
          ...state.newTicketStepOne,
          hasError: true,
          errorMessage:
            action.payload instanceof Error && action.payload.message !== ''
              ? action.payload.message
              : 'An error occurred while trying to load the step one tickets type',
        },
      }
    case STEP_ONE_FOCUS_POSITION:
      return {
        ...state,
        newTicketStepOne: {
          ...state.newTicketStepOne,
          stepOnePositionFocusId: action.payload.position,
        },
      }
    case STEP_ONE_FOCUS:
      return {
        ...state,
        newTicketStepOne: {
          ...state.newTicketStepOne,
          stepOneFocusId: action.payload.id,
        },
      }
    case STEP_ONE_SELECT:
      return {
        ...state,
        newTicketStepOne: {
          ...state.newTicketStepOne,
          stepOneSelectedId: action.payload.id,
        },
      }
    case STEP_TWO_FETCH_OPTIONS:
      return {
        ...state,
        newTicketStepTwo: {
          ...state.newTicketStepTwo,
          isReady: true,
          stepTwoTypes: action.payload.options,
        },
      }

    case STEP_TWO_FOCUS:
      return {
        ...state,
        newTicketStepTwo: {
          ...state.newTicketStepTwo,
          stepTwoFocusId: action.payload.id,
        },
      }
    case STEP_TWO_SELECT:
      return {
        ...state,
        newTicketStepTwo: {
          ...state.newTicketStepTwo,
          stepTwoSelectedId: action.payload.id,
        },
      }

    case FETCH_CHANNELS_REQUEST:
      return {
        ...state,
        newTicketStepThree: {
          ...state.newTicketStepThree,
        },
      }

    case FETCH_CHANNELS_SUCCESS:
      return {
        ...state,
        newTicketStepThree: {
          ...state.newTicketStepThree,
          isReady: true,
          stepThreeChannelsbyId: action.payload.byId,
          stepThreeChannelsAllIds: action.payload.allIds,
        },
      }
    case FETCH_CHANNELS_FAILURE:
      return {
        ...state,
        newTicketStepThree: {
          ...state.newTicketStepThree,
          hasError: true,
          errorMessage:
            action.payload instanceof Error && action.payload.message !== ''
              ? action.payload.message
              : 'An error occurred while trying to load the step one tickets type',
        },
      }
    case STEP_THREE_FOCUS_POSITION:
      return {
        ...state,
        newTicketStepThree: {
          ...state.newTicketStepThree,
          stepThreePositionFocusId: action.payload.position,
        },
      }
    case STEP_THREE_FOCUS:
      return {
        ...state,
        newTicketStepThree: {
          ...state.newTicketStepThree,
          stepThreeFocusId: action.payload.id,
        },
      }
    case STEP_THREE_SELECT:
      let channels = {}
      Object.keys(state.newTicketStepThree.stepThreeChannelsbyId).map((item, index) => {
        if (item == action.payload.id) {
          channels[item] = {
            ...state.newTicketStepThree.stepThreeChannelsbyId[item],
            isSelected: true,
          }
        } else {
          channels[item] = state.newTicketStepThree.stepThreeChannelsbyId[item]
        }
      })

      return {
        ...state,
        newTicketStepThree: {
          ...state.newTicketStepThree,
          stepThreeChannelsbyId: channels,
        },
      }

    case FOCUS_INPUT:
      return {
        ...state,
        reply: {
          ...state.reply,
          focusedInput: action.payload.focusedInput,
          focusedRow: action.payload.focusedRow,
          focusedCol: action.payload.focusedCol,
        },
      }
    case UPDATE_INPUT:
      return {
        ...state,
        reply: {
          ...state.reply,
          [state.reply.focusedInput]: action.payload.newKey,
          errors: {
            ...state.reply.errors,
            [state.reply.focusedInput]: '',
          },
        },
      }
    case DELETE_INPUT:
      return {
        ...state,
        reply: {
          ...state.reply,
          [state.reply.focusedInput]: state.reply[state.reply.focusedInput].substr(
            0,
            state.reply[state.reply.focusedInput].length - 1
          ),
          errors: {
            ...state.reply.errors,
            [state.reply.focusedInput]: '',
          },
        },
      }
    case ERROR_INPUT:
      return {
        ...state,
        reply: {
          ...state.reply,
          errors: {
            ...state.reply.errors,
            [action.payload.input]: action.payload.error,
          },
        },
      }
    case SET_STATUS:
      return {
        ...state,
        reply: {
          ...state.reply,
          status: action.payload.status,
        },
      }
    case FOCUS_KEYBOARD:
      return {
        ...state,
        reply: {
          ...state.reply,
          keyboardFocused: action.payload.focus,
        },
      }
    case REPLY_REQUEST:
      return {
        ...state,
        reply: {
          ...state.reply,
          status: REPLY_STATUS_PROCESSING,
        },
      }
    case REPLY_SUCCESS:
      return {
        ...state,
        reply: {
          ...state.reply,
          status: REPLY_STATUS_SUCCESS,
          [REPLY_INPUT_MESSAGE]: '',
          [REPLY_INPUT_TITLE]: '',
        },
      }
    case REPLY_FAILURE:
      return {
        ...state,
        reply: {
          ...state.reply,
          status: REPLY_STATUS_FAILED,
          statusReason: action.payload.message,
        },
      }
    case RESET_REPLY:
      //reset selected channels
      let channelsItems = {}
      Object.keys(state.newTicketStepThree.stepThreeChannelsbyId).map((item, index) => {
        channelsItems[item] = {
          ...state.newTicketStepThree.stepThreeChannelsbyId[item],
          isSelected: false,
        }
      })

      return {
        ...state,
        newTicketStepOne: {
          ...state.newTicketStepOne,
          stepOnePositionFocusId: -1,
          stepOneFocusId: -1,
          stepOneSelectedId: -1,
        },
        newTicketStepTwo: {
          ...state.newTicketStepTwo,
          stepTwoFocusId: -1,
          stepTwoSelectedId: -1,
        },
        newTicketStepThree: {
          ...state.newTicketStepThree,
          stepThreePositionFocusId: -1,
          stepThreeFocusId: -1,
          stepThreeChannelsbyId: channelsItems,
        },
      }

    /*ticket details*/
    case FETCH_TICKET_DETAILS_REQUEST:
      return {
        ...state,
        ticketDetails: {
          ...state.ticketDetails,
          isReady: false,
          hasError: false,
          errorMessage: '',
        },
      }
    case FETCH_TICKET_DETAILS_SUCCESS:
      let logs = []
      let logsById = {}

      action.payload.ticket.logs.forEach(log => {
        logsById[log.comment_id] = log
        logs.push(log.comment_id)
      })
      return {
        ...state,
        ticketDetails: {
          ...state.ticketDetails,
          details: action.payload.ticket.detail,
          logsById: logsById,
          logsId: logs,
          isReady: true,
          focusedLogId: -1,
          focusedLogPosition: -1,
        },
      }

    case FETCH_TICKET_DETAILS_FAILURE:
      return {
        ...state,
        ticketDetails: {
          ...state.ticketDetails,
          hasError: true,
          errorMessage:
            action.payload instanceof Error && action.payload.message !== ''
              ? action.payload.message
              : 'An error occurred while trying to load the ticket details',
        },
      }
    case FOCUS_LOG:
      return {
        ...state,
        ticketDetails: {
          ...state.ticketDetails,
          focusedLogId: action.payload.id,
        },
      }
    case FOCUS_LOG_POSITION:
      return {
        ...state,
        ticketDetails: {
          ...state.ticketDetails,
          focusedLogPosition: action.payload.position,
        },
      }
    case DISMISS_LOGS_ERROR:
      return {
        ...state,
        ticketDetails: {
          ...state.ticketDetails,
          isReady: true,
          hasError: false,
          errorMessage: '',
        },
      }

    /*reply log*/
    case FOCUS_LOG_INPUT:
      return {
        ...state,
        replyLog: {
          ...state.replyLog,
          focusedInput: action.payload.focusedInput,
          focusedRow: action.payload.focusedRow,
          focusedCol: action.payload.focusedCol,
        },
      }
    case UPDATE_LOG_INPUT:
      return {
        ...state,
        replyLog: {
          ...state.replyLog,
          [state.replyLog.focusedInput]:
            state.replyLog[state.replyLog.focusedInput] + action.payload.newKey,
          errors: {
            ...state.replyLog.errors,
            [state.replyLog.focusedInput]: '',
          },
        },
      }
    case DELETE_LOG_INPUT:
      return {
        ...state,
        replyLog: {
          ...state.replyLog,
          [state.replyLog.focusedInput]: state.replyLog[
            state.replyLog.focusedInput
          ].substr(0, state.replyLog[state.replyLog.focusedInput].length - 1),
          errors: {
            ...state.replyLog.errors,
            [state.replyLog.focusedInput]: '',
          },
        },
      }
    case ERROR_LOG_INPUT:
      return {
        ...state,
        replyLog: {
          ...state.replyLog,
          errors: {
            ...state.replyLog.errors,
            [action.payload.input]: action.payload.error,
          },
        },
      }
    case SET_LOG_STATUS:
      return {
        ...state,
        replyLog: {
          ...state.replyLog,
          status: action.payload.status,
        },
      }
    case FOCUS_LOG_KEYBOARD:
      return {
        ...state,
        replyLog: {
          ...state.replyLog,
          keyboardFocused: action.payload.focus,
        },
      }
    case REPLY_LOG_REQUEST:
      return {
        ...state,
        replyLog: {
          ...state.replyLog,
          status: REPLY_LOG_STATUS_PROCESSING,
        },
      }
    case REPLY_LOG_SUCCESS:
      return {
        ...state,
        replyLog: {
          ...state.replyLog,
          status: REPLY_LOG_STATUS_SUCCESS,
          [REPLY_LOG_INPUT_MESSAGE]: '',
        },
      }
    case REPLY_LOG_FAILURE:
      return {
        ...state,
        replyLog: {
          ...state.replyLog,
          status: REPLY_LOG_STATUS_FAILED,
          statusReason: action.payload.message,
        },
      }
    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case NEW_SUPPORT_TICKET:
      return {
        ...INITIAL_STATE,
      }

    default:
      return state
  }
}

export default ticketsReducer
